import { useEffect, useState } from 'react';
import { getMultimediaLevels } from '../../services/calculator/getMultimediaLevelsService.js';

export const useMultimediaLevels = () => {
    const [multimediaLevels, setMultimediaLevels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const loadMultimediaLevels = async () => {
            try {
                const data = await getMultimediaLevels();
                setMultimediaLevels(data);
            } catch {
                setError('Error cargando los niveles multimedia.');
            } finally {
                setLoading(false);
            }
        };

        loadMultimediaLevels();
    }, []);

    return {
        multimediaLevels,
        loading,
        error
    };
}